import {ImportDataComponent, ImportDataComponentProps} from "@components/shared/ImportDataComponent.tsx";
import React from "react";
import usePublic from "@shared/hooks/usePublic.ts";
import {IProduto} from "@models/produtos/produto.ts";
import type {ICreateProdutoDto} from "@models/produtos/produtosDto.ts";
import {useProduto} from "@components/produtos/hooks/useProduto.ts";

interface ImportProdutoComponentProps {
    onCreate: (v?: IProduto[]) => void
}

export function ImportProdutoComponent(props: ImportProdutoComponentProps) {
    const {onCreate} = props;
    const {getTemplate} = usePublic()
    const {importProdutos} = useProduto()

    const importProps: ImportDataComponentProps<ICreateProdutoDto, IProduto> = {
        onCreate: onCreate,
        filename: "produto.csv",
        importMethod: importProdutos,
        previewGrid: [{field: 'nome', headerName: 'Nome', width: 100},
            {field: 'descricao', headerName: 'Descrição', width: 150},
            {field: "idErp", headerName: 'Id do produto no Erp', width: 200},
            {field: 'idFamiliaErp', headerName: 'Id da Familia no Erp', width: 200},
        ],
        templateUrl: getTemplate('produto', 'import-example'),

    }
    return (
        <ImportDataComponent {...importProps}/>
    )
}